import { render, staticRenderFns } from "./AboutBettingMarkets.vue?vue&type=template&id=6cd46306&"
import script from "./AboutBettingMarkets.vue?vue&type=script&lang=js&"
export * from "./AboutBettingMarkets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports